// extracted by mini-css-extract-plugin
export default {"root":"_325kV","link-overlay":"_2B3qQ","linkOverlay":"_2B3qQ"};